import { HistoryIcon } from "../../../../assets/svg/HistoryIcon";
import { LeftDrawer } from "../../../../shared/LeftDrawer/LeftDrawer";
import { CloseIcon } from "../../../../assets/svg/CloseIcon";
import styles from "./HistoryButton.module.scss";
import {
  EViewType,
  useURLRouting,
} from "../../../../utils/hooks/useURLRouting";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { HistoryList } from "../HistoryList/HistoryList";
import { HistoryService } from "../../../../services/HistoryService";
import { getHistoryCount } from "../../../../redux/reducers/history/historySelectors";
import { Pagination } from "../../../../components/Pagination/Pagination";
import { useEffect } from "react";
import { getHistoryListThunk } from "../../../../redux/reducers/history/historyThunks";
import { getUser } from "../../../../redux/reducers/user/userSelectors";
import { useUrlPagination } from "../../../../utils/hooks/useUrlPagination";

export const HistoryButton = () => {
  const dispatch = useAppDispatch();
  const { currentView, setHistory, resetHistory } = useURLRouting();
  const PAGINATION_KEY = "history";
  const { page, setPage } = useUrlPagination(PAGINATION_KEY);
  const historyCount = useAppSelector(getHistoryCount());
  const user = useAppSelector(getUser());
  const userID = user && user.id >= 0 && user.id;
  const isShowHistoryList =
    currentView && currentView.type === EViewType.History;

  const handleToggleDrawer = (): void => {
    if (currentView?.type === EViewType.History) {
      resetHistory();
    } else {
      setHistory("");
    }
  };

  const getHistoryList = async (id: number) => {
    await dispatch(getHistoryListThunk({ id, page })).unwrap();
  };

  useEffect(() => {
    if (userID) {
      getHistoryList(userID);
    }
  }, []);

  useEffect(() => {
    if (userID) {
      getHistoryList(userID);
    }
  }, [page]);

  useEffect(() => {
    if (userID && isShowHistoryList) {
      getHistoryList(userID);
    }
  }, [isShowHistoryList]);

  return (
    <>
      <button
        type="button"
        onClick={handleToggleDrawer}
        className={currentView.type === EViewType.History ? "active" : ""}
        data-tour="render-history-btn"
      >
        <HistoryIcon />
      </button>
      {isShowHistoryList ? (
        <LeftDrawer>
          <div className={styles.wrapper}>
            <div className={styles.header}>
              Render history
              <button onClick={() => resetHistory()}>
                <CloseIcon />
              </button>
            </div>
            <div className={styles.content_wrapper}>
              <HistoryList />
            </div>
            <div className={styles.footer}>
              <Pagination
                currentPage={page}
                totalPages={HistoryService.getPagesCount(historyCount)}
                onPageChange={setPage}
              />
            </div>
          </div>
        </LeftDrawer>
      ) : null}
    </>
  );
};
